import {mixins} from "../app/mixin";

mixins.push({
    el: '.careerOpenPositionsPage',
    data() {
        return {
            selectedStep: 0,
            selectedDepartment: 0
        }
    }, methods: {
        selectStepCard(stepCardId) {
            if (this.selectedStep !== stepCardId) {
                this.selectedStep = stepCardId
            }
        },
        selectDepartment(index) {
            if (index !== this.selectedDepartment) {
                this.selectedDepartment = index;
            }
        }
    }
});
